import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { BaseMultipleWidget } from '@website-builder/widgets/base/base-multiple-widget';
import { GalleryContentStyle } from '@website-builder/widgets/gallery/model/gallery-content-style';
import { GalleryButtonStyle } from '@website-builder/widgets/gallery/model/gallery-button-style';
import { GalleryTitleStyle } from '@website-builder/widgets/gallery/model/gallery-title-style';
import { GalleryImageStyle } from '@website-builder/widgets/gallery/model/gallery-image-style';
import { GalleryItemStyle } from '@website-builder/widgets/gallery/model/gallery-item-style';
import { GalleryOverlay } from '@website-builder/widgets/gallery/model/gallery-overlay';
import { GalleryConfig } from '@website-builder/widgets/gallery/model/gallery-config';
import { GalleryStyle } from '@website-builder/widgets/gallery/model/gallery-style';
import { GalleryElement } from '@website-builder/widgets/gallery/gallery-element';
import { GallerySubtitleStyle } from '@website-builder/widgets/gallery/model/gallery-subtitle-style';
import { GalleryLightboxStyle } from '@website-builder/editor/sidebar/edit-components/gallery-edit/models/gallery-lightbox-style';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class GalleryWidget extends BaseMultipleWidget<GalleryElement, GalleryStyle> {
  readonly type = BuilderElementType.Gallery;
  style = new GalleryStyle();
  config = new GalleryConfig();
  overlay = new GalleryOverlay();
  itemStyle = new GalleryItemStyle();
  titleStyle = new GalleryTitleStyle();
  imageStyle = new GalleryImageStyle();
  buttonStyle = new GalleryButtonStyle();
  contentStyle = new GalleryContentStyle();
  subtitleStyle = new GallerySubtitleStyle();
  lightboxStyle = new GalleryLightboxStyle();

  elements = [
    new GalleryElement('assets/images/builder/placeholders/cityscape.png'),
    new GalleryElement('assets/images/builder/placeholders/cityview.png'),
    new GalleryElement('assets/images/builder/placeholders/mountain.png'),
    new GalleryElement('assets/images/builder/placeholders/mountain.png'),
    new GalleryElement('assets/images/builder/placeholders/cityscape.png'),
    new GalleryElement('assets/images/builder/placeholders/cityview.png'),
  ];

  static normalizeInPlace(widget: GalleryWidget): GalleryWidget {
    const pureWidget = new GalleryWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.elements = (widget.elements ?? pureWidget.elements).map(element => GalleryElement.normalizeInPlace(element));
    widget.style = GalleryStyle.normalize(widget.style);
    widget.config = GalleryConfig.normalize(widget.config);
    widget.overlay = GalleryOverlay.normalize(widget.overlay);
    widget.itemStyle = GalleryItemStyle.normalize(widget.itemStyle);
    widget.titleStyle = GalleryTitleStyle.normalize(widget.titleStyle);
    widget.imageStyle = GalleryImageStyle.normalize(widget.imageStyle);
    widget.buttonStyle = GalleryButtonStyle.normalize(widget.buttonStyle);
    widget.contentStyle = GalleryContentStyle.normalize(widget.contentStyle);
    widget.subtitleStyle = GallerySubtitleStyle.normalize(widget.subtitleStyle);
    widget.lightboxStyle = GalleryLightboxStyle.normalize(widget.lightboxStyle);

    return widget;
  }
}
